// extracted by mini-css-extract-plugin
module.exports = {"TopSection":"TopSection_TopSection__3vqfi","ImageContainers":"TopSection_ImageContainers__1g3aq","Title":"TopSection_Title__154cm","GooglePlay":"TopSection_GooglePlay__1oKL5"};